// prettier-ignore
const ApplicationCenterHome = () => import('../visa-application/application-center-home/application-center-home.vue');
// prettier-ignore
const ApplierResidenceCountry = () => import('../visa-application/applier-residence-country/applier-residence-country.vue');
// prettier-ignore
const ApplierApplicationCenter = () => import('../visa-application/applier-application-center/applier-application-center.vue');
// prettier-ignore
const ApplierVisaSubtype = () => import('../visa-application/applier-visa-subtype/applier-visa-subtype.vue');
// prettier-ignore
const Login = () => import('../visa-application/login/login.vue');
const Logout = () => import('../visa-application/logout/logout.vue');
const StaticAddedValueServices = () => import('../info/static_added_value_services/static_added_value_services.vue');
const Faq = () => import('../info/faq/faq.vue');
const News = () => import('../info/news/news.vue');
const LegalMentions = () => import('../info/legal-mentions/legal-mentions.vue');
const LegalPrivacy = () => import('../info/legal-privacy/legal-privacy.vue');
const LegalCookiePolicy = () => import('../info/legal-cookie-policy/legal-cookie-policy.vue');
const LegalTermsService = () => import('../info/legal-terms-service/legal-terms-service.vue');
const LegalTermsWebsite = () => import('../info/legal-terms-website/legal-terms-website.vue');
const OpeningHours = () => import('../info/opening-hours/opening-hours.vue');
const Procedure = () => import('../info/procedure/procedure.vue');
const ProcedurePostal = () => import('../info/procedure-postal/procedure-postal.vue');
const ProcedureEmbassy = () => import('../info/procedure-embassy/procedure-embassy.vue');
const ProcedureOrganization = () => import('../info/procedure-organization/procedure-organization.vue');
const LinksDownloads = () => import('../info/links-downloads/links-downloads.vue');
const Inquiry = () => import('../info/inquiry/inquiry.vue');
const TrackMyApplication = () => import('../info/track-my-application/track-my-application.vue');
const SecurityNotice = () => import('../info/security-notice/security-notice.vue');
const ApplicationFees = () => import('../info/application-fees/application-fees.vue');
const TravelInsurance = () => import('../info/travel-insurance/travel-insurance.vue');
const CovidSanitaryMeasures = () => import('../info/covid-sanitary-measures/covid-sanitary-measures.vue');
const Register = () => import('../core/register/register.vue');
const Assistance = () => import('../info/visa-assistance/visa-assistance.vue');

function generateSitemapByIssuer(type = 'country') {
  const sitemapIssuers = process.env.GENERATE_SITEMAP_ISSUER;
  if (sitemapIssuers === undefined || sitemapIssuers === 'undefined') {
    return [{ residenceCountryCode: '', issuer: '' }];
  }
  const issuers = sitemapIssuers.split(',').map(issuer => issuer.trim());
  const countries = Array.from(new Set(issuers.map(issuer => issuer.substr(0, 2))));
  const sitemapData = [];
  if (type === 'country') {
    countries.forEach(country => {
      sitemapData.push({ residenceCountryCode: country });
    });
  } else {
    countries.forEach(country => {
      issuers.forEach(issuer => {
        if (issuer.substr(0, 2) === country) {
          sitemapData.push({ residenceCountryCode: country, issuer });
        }
      });
    });
  }
  return sitemapData;
}

const isVisaCutService = () => {
  return process.env.IS_SERVICE === 'true';
};

// add osano integration
if (
  process.env.OSANO_CUSTOMER_ID &&
  process.env.OSANO_CONFIG_ID &&
  typeof window !== 'undefined' &&
  (process.env.OSANO_CUSTOMER_ID && process.env.OSANO_CONFIG_ID) !== 'undefined'
) {
  const osano = document.createElement('script');
  const s = document.getElementsByTagName('head')[0];
  const csp = '272157fdbefe593b565323d9144662c8';
  osano.src = `https://cmp.osano.com/${process.env.OSANO_CUSTOMER_ID}/${process.env.OSANO_CONFIG_ID}/osano.js`;
  osano.setAttribute('nonce', csp);
  setTimeout(function() {
    s.appendChild(osano);
  }, 2000);
}

// add Datadome integration
if (
  process.env.DATADOME_ID !== undefined &&
  process.env.DATADOME_ID !== 'undefined' &&
  typeof window !== 'undefined' &&
  process.env.DATADOME_ID !== ''
) {
  window.ddjskey = process.env.DATADOME_ID;
  window.ddoptions = { ajaxListenerPath: true } || null;
  const m = document.createElement('script');
  const n = document.getElementsByTagName('script')[0];
  const csp = '272157fdbefe593b565323d9144662c8';
  m.async = 1;
  m.src = 'https://js.datadome.co/tags.js?id=' + process.env.DATADOME_ID;
  m.setAttribute('nonce', csp);
  setTimeout(function() {
    n.parentNode.insertBefore(m, n);
  }, 2000);
}

// add GTM
if (process.env.GTM_ID !== undefined && process.env.GTM_ID !== 'undefined' && typeof window !== 'undefined' && process.env.GTM_ID !== '') {
  const gtm = document.createElement('script');
  const head = document.getElementsByTagName('head')[0];
  const csp = '272157fdbefe593b565323d9144662c8';
  const gtmscript = document.createTextNode(`(function(w, d, s, l, i, ) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    j.setAttribute('nonce', '272157fdbefe593b565323d9144662c8');
    f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer','${process.env.GTM_ID}');`);
  gtm.appendChild(gtmscript);

  const body = document.getElementsByTagName('body')[0];
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = 'https://www.googletagmanager.com/ns.html?id=' + process.env.GTM_ID;
  iframe.setAttribute('nonce', csp);
  iframe.height = '0';
  iframe.width = '0';
  iframe.style = 'display:none;visibility:hidden';

  setTimeout(function() {
    body.insertBefore(noscript, body.nextElementSibling);
    noscript.appendChild(iframe);
    head.appendChild(gtm);
  }, 2000);
}

module.exports.routes = [
  // --- User routes --- //
  {
    path: '/',
    name: 'ApplierResidenceCountry',
    component: ApplierResidenceCountry
  },
  {
    path: '/visa/:residenceCountryCode',
    name: 'ApplierApplicationCenter',
    component: ApplierApplicationCenter,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer()
      }
    },
    beforeEnter(to, from, next) {
      // 如果是 hmpo环境 或者是legalization 环境就切换显示路径
      // If the environment is HMPO or Legalization, switch the display path
      let SERVICE_PATH = '/visa/';
      if (isVisaCutService()) {
        SERVICE_PATH = '/service/';
      }
      if (
        !window.location.href.includes(process.env.REDIRECT_URL) && //do nothing when on WAF
        process.env.REDIRECT_URL !== undefined &&
        process.env.REDIRECT_COUNTRY_CODE.split(',').includes(to.params.residenceCountryCode)
      ) {
        window.location.href = 'https://' + process.env.REDIRECT_URL + SERVICE_PATH + to.params.residenceCountryCode;
      } else if (isVisaCutService()) {
        next({
          name: 'ApplierApplicationCenterService',
          params: {
            residenceCountryCode: to.params.residenceCountryCode
          }
        });
      } else next();
    }
  },
  {
    path: '/visa/:residenceCountryCode/:issuer/home',
    name: 'ApplicationCenterHome',
    component: ApplicationCenterHome,
    beforeEnter(to, from, next) {
      // 如果是 hmpo环境 或者是legalization 环境就切换显示路径
      // If the environment is HMPO or Legalization, switch the display path
      let SERVICE_PATH = '/visa/';
      if (isVisaCutService()) {
        SERVICE_PATH = '/service/';
      }
      if (
        process.env.REDIRECT_COUNTRY_CODE.split(',').includes(to.params.residenceCountryCode) &&
        process.env.REDIRECT_URL !== undefined &&
        !window.location.href.includes(process.env.REDIRECT_URL) //do nothing when on WAF
      ) {
        window.location.href =
          'https://' + process.env.REDIRECT_URL + SERVICE_PATH + to.params.residenceCountryCode + '/' + to.params.issuer + '/home';
      } else if (isVisaCutService()) {
        next({
          name: 'ApplicationCenterHomeService',
          params: {
            residenceCountryCode: to.params.residenceCountryCode,
            issuer: to.params.issuer
          }
        });
      } else next();
    },
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    // hmpo Route 'visa' to 'service'
    path: '/service/:residenceCountryCode',
    name: 'ApplierApplicationCenterService',
    component: ApplierApplicationCenter,
    beforeEnter(to, from, next) {
      if (
        process.env.REDIRECT_COUNTRY_CODE.split(',').includes(to.params.residenceCountryCode) &&
        process.env.REDIRECT_URL !== undefined &&
        !window.location.href.includes(process.env.REDIRECT_URL) //do nothing when on WAF
      ) {
        window.location.href = 'https://' + process.env.REDIRECT_URL + '/service/' + to.params.residenceCountryCode;
      } else next();
    },
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer()
      }
    }
  },
  {
    // hmpo Route 'visa' to 'service'
    path: '/service/:residenceCountryCode/:issuer/home',
    name: 'ApplicationCenterHomeService',
    component: ApplicationCenterHome,
    beforeEnter(to, from, next) {
      if (
        process.env.REDIRECT_COUNTRY_CODE.split(',').includes(to.params.residenceCountryCode) &&
        process.env.REDIRECT_URL !== undefined &&
        !window.location.href.includes(process.env.REDIRECT_URL) //do nothing when on WAF
      ) {
        window.location.href =
          'https://' + process.env.REDIRECT_URL + '/service/' + to.params.residenceCountryCode + '/' + to.params.issuer + '/home';
      } else next();
    },
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/visa/:residenceCountryCode/:issuer/info',
    name: 'ApplierTravelPurposeTheme',
    component: ApplierVisaSubtype,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    },
    beforeEnter(to, from, next) {
      // 如果是 hmpo环境 或者是legalization 环境就切换显示路径
      // If the environment is HMPO or Legalization, switch the display path
      if (isVisaCutService()) {
        next({
          name: 'ApplierTravelPurposeThemeService',
          params: {
            residenceCountryCode: to.params.residenceCountryCode,
            issuer: to.params.issuer
          }
        });
      } else next();
    }
  },
  {
    path: '/service/:residenceCountryCode/:issuer/info',
    name: 'ApplierTravelPurposeThemeService',
    component: ApplierVisaSubtype,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  // Account routes
  {
    path: '/login/:residenceCountryCode/:issuer',
    name: 'Login',
    component: Login,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/logout/:residenceCountryCode/:issuer',
    name: 'Logout',
    component: Logout,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  // Static pages
  {
    path: '/register/:residenceCountryCode/:issuer',
    name: 'Register',
    component: Register,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/added-value-services/:residenceCountryCode/:issuer',
    name: 'StaticAddedValueServices',
    component: StaticAddedValueServices,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/faq/:residenceCountryCode/:issuer',
    name: 'Faq',
    component: Faq,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/news/:residenceCountryCode/:issuer',
    name: 'News',
    component: News,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/opening-hours/:residenceCountryCode/:issuer',
    name: 'OpeningHours',
    component: OpeningHours,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/procedure/:residenceCountryCode/:issuer',
    name: 'Procedure',
    component: Procedure,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/procedure-postal/:residenceCountryCode/:issuer',
    name: 'ProcedurePostal',
    component: ProcedurePostal,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/procedure-embassy/:residenceCountryCode/:issuer',
    name: 'ProcedureEmbassy',
    component: ProcedureEmbassy,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/procedure-organization/:residenceCountryCode/:issuer',
    name: 'ProcedureOrganization',
    component: ProcedureOrganization,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/links-downloads/:residenceCountryCode/:issuer',
    name: 'Downloads',
    component: LinksDownloads,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/security-notice/:residenceCountryCode/:issuer',
    name: 'SecurityNotice',
    component: SecurityNotice,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/application-fees/:residenceCountryCode/:issuer',
    name: 'ApplicationFees',
    component: ApplicationFees,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/inquiry/:residenceCountryCode/:issuer',
    name: 'Inquiry',
    component: Inquiry,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/legal/:residenceCountryCode/:issuer',
    name: 'LegalMentions',
    component: LegalMentions,
    meta: {
      metaInfo: {
        meta_title: 'Customer Gateway'
      },
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/privacy-notice/:residenceCountryCode/:issuer',
    name: 'LegalPrivacy',
    component: LegalPrivacy,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/cookie-policy/:residenceCountryCode/:issuer',
    name: 'LegalCookiePolicy',
    component: LegalCookiePolicy,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/terms-of-service/:residenceCountryCode/:issuer',
    name: 'LegalTermsService',
    component: LegalTermsService,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/terms-of-website-use/:residenceCountryCode/:issuer',
    name: 'LegalTermsWebsite',
    component: LegalTermsWebsite,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/track-my-application/:residenceCountryCode/:issuer',
    name: 'TrackMyApplication',
    component: TrackMyApplication,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/travel-insurance/:residenceCountryCode/:issuer',
    name: 'TravelInsurance',
    component: TravelInsurance,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/covid-sanitary-measures/:residenceCountryCode/:issuer',
    name: 'CovidSanitaryMeasures',
    component: CovidSanitaryMeasures,
    meta: {
      metaInfo: {
        meta_title: 'Customer Gateway'
      },
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  },
  {
    path: '/assistance-visa/:residenceCountryCode/:issuer',
    name: 'AssistanceVisa',
    component: Assistance,
    meta: {
      sitemap: {
        slugs: () => generateSitemapByIssuer('issuer')
      }
    }
  }
];
